// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { RegistrarServiceRequest } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Registrar';
import { ContractId, Party } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useAcceptRegistrarServiceRequest: () => UseMutationResult<
  void,
  string,
  {
    registrarServiceRequestCid: ContractId<RegistrarServiceRequest>;
    compliance: Party;
    instrumentSecurityControl: Party;
    participantAgent: Party;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();

  return useMutation({
    mutationKey: ['acceptRegistryRegistrarServiceRequest', ledgerApi, operator],
    mutationFn: async ({
      registrarServiceRequestCid,
      compliance,
      instrumentSecurityControl,
      participantAgent,
    }) => {
      return ledgerApi.acceptRegistryRegistrarServiceRequest(
        registrarServiceRequestCid,
        compliance,
        instrumentSecurityControl,
        participantAgent,
      );
    },
    retry: false,
  });
};

export default useAcceptRegistrarServiceRequest;
